export interface BookingCounterparty {
  id?: string;
  name?: string;
  photoUrl?: string;
  contactAvailable?: boolean;
  viewerHasMessaged?: boolean;
}

export function isCounterpartyContactAvailable(counterparty: BookingCounterparty | null | undefined): boolean {
  if (!counterparty) {
    return false;
  }

  return counterparty.contactAvailable !== false;
}

export function counterpartyDisplayName(counterparty: BookingCounterparty | null | undefined, fallback: string): string {
  return counterparty?.name || fallback;
}

export function counterpartyContactButtonText(counterparty: BookingCounterparty | null | undefined, fallback: string): string {
  if (!counterparty) {
    return 'Unavailable for contact';
  }

  if (!isCounterpartyContactAvailable(counterparty)) {
    return 'Unavailable for contact';
  }

  return `Message ${counterpartyDisplayName(counterparty, fallback)}`;
}

export function shouldShowCounterpartyContactButton(
  counterparty: BookingCounterparty | null | undefined,
  options: { requirePriorMessage?: boolean } = {}
): boolean {
  if (!counterparty) {
    return false;
  }

  if (!isCounterpartyContactAvailable(counterparty)) {
    return true;
  }

  if (options.requirePriorMessage) {
    return counterparty.viewerHasMessaged === true;
  }

  return true;
}

export type LockedCounterpartyRole = 'parent' | 'sitter';

export function shouldShowLockedCounterpartyBanner(counterparty: BookingCounterparty | null | undefined): boolean {
  return !!counterparty && !isCounterpartyContactAvailable(counterparty);
}

export function lockedCounterpartyBannerMessage(role: LockedCounterpartyRole): string {
  if (role === 'sitter') {
    return 'Additional information is needed from the care provider in order to proceed with the booking.';
  }

  return 'Additional information is needed from the family in order to proceed with the booking.';
}

export function lockedParentConfirmCareBannerMessage(): string {
  return 'More information is needed from the family to confirm care';
}
